import { styled } from '@mui/material';



export const FC = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '1rem',
  backgroundColor: 'white'
});
